// extracted by mini-css-extract-plugin
export default {"content":"EmailRead_content__MHp0D","notFound":"EmailRead_notFound__q9YKr","strikethrough":"EmailRead_strikethrough__8mzFG"};